import tbPopUpV2 from './tb-pop-up-v2.component'

export default angular
  .module('tb.pop-up-v2', [])
  .component('tbPopUpV2', tbPopUpV2)
  .name
